import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-upload',
  standalone: false,
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {
  @ViewChild('fileData') fileData!: ElementRef
  @Output() dataEmitter = new EventEmitter<string[]>();
  @Input() keyFile: any
  @Output() uploadData: EventEmitter<any> = new EventEmitter<any>();
  @Input() downloadSample!: () => void;
  selectedFile: File | null = null;
  fileContent: string | null = null;
  isUploading = false;
  uploadProgress = 0;
  errorMessage: string | null = null;
  isDragOver = false;
  parsedData: any[] = [];
  constructor(
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
  }
  onFileSelected(event: any): void {
    this.handleFileSelection(event.target.files[0]);
  }
  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    if (event.dataTransfer?.files) {
      this.handleFileSelection(event.dataTransfer.files[0]);
    }
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }
  private handleFileSelection(file: File): void {
    this.errorMessage = null;
    if (file.type != 'text/csv' && file.type != 'application/vnd.ms-excel') {
      this.errorMessage = 'Invalid file type. Please upload an CSV.';
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const csvText = reader.result as string;
      this.parsedData = this.parseCSV(csvText);
      this.parsedData = this.parsedData.filter((item: any) => {
        this.keyFile.forEach((e: any) => {
          if (item[e] == '' || item[e] == null || item[e] == undefined) {
            delete item[e]
          }
        });
        return item;
      })
    };
    reader.readAsText(file);
  }

  parseCSV(csvText: string, delimiter = ','): any[] {
    const lines = csvText.split(/\r?\n/);
    const result = [];

    const parseLine = (line: string) => {
      const cols = [];
      let current = '';
      let insideQuotes = false;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];

        if (char === '"') {
          if (insideQuotes && line[i + 1] === '"') {
            current += '"'; // escaped quote
            i++;
          } else {
            insideQuotes = !insideQuotes;
          }
        } else if (char === delimiter && !insideQuotes) {
          cols.push(current);
          current = '';
        } else {
          current += char;
        }
      }
      cols.push(current); // last field
      return cols;
    };

    const headers = parseLine(lines[0]);
    for (let i = 1; i < lines.length; i++) {
      if (lines[i].trim() === '') continue; // skip empty lines
      const values = parseLine(lines[i]);
      const row: any = {};
      headers.forEach((key, idx) => {
        row[key] = values[idx];
      });
      result.push(row);
    }

    return result;
  }

  onUpload(): void {
    if (!this.selectedFile) return;
    this.isUploading = true;
    this.uploadProgress = 0;
    const progressInterval = setInterval(() => {
      this.uploadProgress += 10;
      if (this.uploadProgress >= 100) {
        clearInterval(progressInterval);
        this.readFileContent();
      }
    }, 200);
  }
  private readFileContent(): void {
    if (!this.selectedFile) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.fileContent = reader.result as string;
      this.isUploading = false;
    };
    reader.onerror = () => {
      this.errorMessage = 'Error reading file';
      this.isUploading = false;
      this.uploadProgress = 0;
    };

    reader.readAsText(this.selectedFile);
  }
  clearFile(): void {
    this.selectedFile = null;
    this.uploadProgress = 0;
    this.errorMessage = null;
  }
  clearAll(): void {
    this.clearFile();
    this.fileContent = null;
  }
  upload() {
    this.uploadData.emit(this.parsedData);
    this.parsedData = [];
  }
}



